@if (fallbackUrl && !showParticipant) {
    <img fill ngSrcset="1x, 2x, 3x" [ngSrc]="fallbackUrl" />
}
@if (participantUrl) {
    <img fill ngSrcset="1x, 2x, 3x" [ngSrc]="participantUrl" [hidden]="!showParticipant" (load)="participantImageLoad()" />
}
